
import md5 from 'js-md5'
import { getToken, setToken, removeToken } from '@/utils/auth'
const urlPrefix = "https://api.hutlon.com/api/admin"; //正式api地址
const urlPrefixNoAdmin = "https://api.hutlon.com/api"; //正式api地址
const urlPrefixNoApi = "https://api.hutlon.com"; //正式api地址

var SignRequest = {
  urlPrefix:"https://api.hutlon.com/api/admin",
  urlPrefixNoAdmin:'https://api.hutlon.com/api',
  urlPrefixNoApi:'https://api.hutlon.com',
  signkey: "SIGNKEY=htl@i#y*71nK*ePu46M%",
  token: "TOKEN=",
  timestamp: "TIMESTAMP=",
  //获取服务器时间
  severtime: function () {
    var dateTime;
    $.ajax({
      url: this.urlPrefixNoAdmin + '/Common/GetServerTime',
      type: "post",
      dataType: 'json',
      async: false,
      success: function (data) {
        dateTime = data;
      },
      error: function () {
        Common.showMsg("提示", "无法获取服务器时间!");
      }
    });
    return dateTime;
  },
  //获取方法名
  methodname: function (method) {
    return "METHODNAME=" + "api/admin" +method;
  },
  //获取Token
  getToken: function () {
    var gettoken =getToken();
    if(gettoken != "" && gettoken != null){
      gettoken ="Bearer "+ getToken();
    }
    return gettoken;
  },
  //设置Token
  setToken: function (token) {
    setToken(token)
  },
  //MD5加密
  tokenmd5string2: function (method, dateTime) {
    var gettoken = this.getToken();

    //token为空不参与加密
    if (gettoken == "" || gettoken == null) {
      return this.signkey + ";" + this.timestamp + dateTime + ";" + this.methodname(method) + ";";
    }

    return this.signkey + ";" + this.timestamp + dateTime + ";" + this.methodname(method) + ";" + this.token + gettoken + ";";
  },
  //设置json数据
  getSign: function (method, dateTime) {
    var sMd5 = this.tokenmd5string2(method, dateTime);
    var iMd5 = md5(sMd5).toUpperCase();
    return iMd5;
  }
};

export default SignRequest



// WEBPACK FOOTER //
// ./src/utils/SignRequest.js